/**
 * Person-level work profile helpers shared by the add/edit employee dialogs.
 * Arbeitstage picker is only relevant for Tage/Woche 1–4 (reference parity).
 */

export interface WorkProfile {
  weeklyHours: string;
  workdaysPerWeek: string;
  workWeekdays: number[];
}

/** Reference parity: fixed Arbeitstage only matter below a full Mon–Fri week. */
export function needsWeekdayPicker(workdaysPerWeek: number): boolean {
  return Number.isFinite(workdaysPerWeek) && workdaysPerWeek >= 1 && workdaysPerWeek <= 4;
}

/** First N ISO weekdays (1=Mon … 7=Sun) — used when the picker is hidden. */
export function defaultWorkWeekdays(workdaysPerWeek: number): number[] {
  const n = Math.min(7, Math.max(1, Math.trunc(workdaysPerWeek)));
  return Array.from({ length: n }, (_unused, index) => index + 1);
}

export function resolveWorkWeekdays(profile: WorkProfile): number[] {
  const days = Number(profile.workdaysPerWeek);
  if (needsWeekdayPicker(days)) {
    return [...profile.workWeekdays].sort((a, b) => a - b);
  }
  return defaultWorkWeekdays(days);
}

export function isWorkProfileWeekdaysValid(profile: WorkProfile): boolean {
  const days = Number(profile.workdaysPerWeek);
  if (!needsWeekdayPicker(days)) return true;
  return profile.workWeekdays.length === days;
}
